 <template>
  <main id="main">
    <section>
      <div class="hold-list">
        <div>
          <span>Electric Buses</span>
          <b>{{ title.car_cnt }} vehicles</b>
        </div>
        <div>
          <span>Avg. Battery Grade</span>
          <b>Grade {{ title.bat_grade }}</b>
        </div>
      </div>

      <div class="wrapper">
        <div class="contents">
          <div class="contents__container contents__container2 cont1">
            <h2 class="title-style-1">Battery Grade Trend</h2>
            <div class="contents__container__year mob">
              <button type="button" class="prev" v-on:click="change_year(1)"></button>
              <p>{{ selectedYear }}</p>
              <button type="button" class="next" v-on:click="change_year(0)"></button>
            </div>
            <div class="contents__container__chart">
              <div class="contents__container__chart__box">
                <div class="container" style="width: 100%; height: 100%;">
                  <div id="anychart2" ref="anychart2" style="width: 100%; height: 100%;"></div>
                </div>
              </div>
              <div class="contents__container__chart__table">
                <ul>
                  <li>
                    <span></span>
                    Grade 1
                  </li>
                  <li>
                    <span></span>
                    Grade 2
                  </li>
                  <li>
                    <span></span>
                    Grade 3
                  </li>
                  <li>
                    <span></span>
                    Grade 4
                  </li>
                  <li>
                    <span></span>
                    Grade 5
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="contents__container contents__container2 cont2">
            <h2 class="title-style-1">Detail Info</h2>
            <div class="contents__container__year">
              <button type="button" class="prev" v-on:click="change_year(1)"></button>
              <p>{{ selectedYear }}</p>
              <button type="button" class="next" v-on:click="change_year(0)"></button>
            </div>
            <div class="contents__container__chart">
              <div class="contents__container__chart__box">
                <div class="container" style="width: 100%; height: 100%;">
                  <div id="anychart" style="width: 100%; height: 100%;" class="chart" ref="anychart"></div>
                </div>
              </div>
              <div class="contents__container__chart__table">
                <ul>
                  <li>
                    <span style="background: #64b5f6;"></span>
                    Remaining Life
                  </li>
                  <li>
                  <span style="background: #ef6c00;"></span>
                    Safety
                  </li>
                  <li>
                  <span style="background: #1976d2;"></span>
                    Usability
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="contents__container contents__container3">
            <h2 class="title-style-1">Route Avg. vs. Vehicle Battery Grade</h2>

            <div class="contents__container__month">
              <div class="contents__container__month__img">
                <img src="@/assets/images/icon/month.png" alt="">
              </div>
              <div class="contents__container__month__btn">
              <ul>
                  <li :key=i v-for="i in 6">
                  <button
                    type="button"
                    @click="selectedMonth = i"
                    :class="selectedMonth == i ? ' active' : ''">
                    M{{ i }}
                  </button>
                </li>
              </ul>
                <ul>
                  <li :key=i v-for="i in 6">
                    <button
                      type="button"
                      @click="selectedMonth = (6 + i)"
                      :class="selectedMonth == (6 + i) ? ' active' : ''">
                      M{{ 6 + i }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="contents__container__select">
              <select class="select-style-1" @change="change_route($event)" v-model="route_select" name="" id="">
                <option v-bind:value="{idx: 0, name:'All Routes'}" >All Routes</option>
                <option v-for="data in route_list" :key="data.idx" v-bind:value="{idx: data.idx, name:data.route_nm}">{{data.route_nm}}</option>
              </select>
              <select class="select-style-1" @change="change_car()" v-model="car_number_select" name="" id="">
                <option v-bind:value="{idx: 0, name:'All Vehicles'}">All Vehicles</option>
                <option v-for="data in car_list" :key="data.idx" v-bind:value="{idx: data.idx, name:data.car_number}">{{data.car_number}}</option>
              </select>
            </div>

            <div class="contents__container__chart">
              <div class="container">
                <section class="chart-container">
                  <div id="anychart3" style="width: 100%; height: 100%;" class="chart" ref="anychart3"></div>
                  <div class="chart-legend">
                    <ul> 
                      <li><span></span>{{ route_select.name }} </li>
                      <li><span></span>{{ car_number_select.name }}</li>
                    </ul>
                  </div>
                </section>
                <section class="table-container">
                  <div class="tbl1">
                    <table>
                      <colgroup>
                        <col style="width: 30%;" />
                        <col style="width: 70%;" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th colspan="2">{{ route_select.name }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>Battery SOH</th>
                          <td>{{ chart3_data[0]['bat_soh'] }} %</td>
                        </tr>
                        <tr>
                          <th>Mileage</th>
                          <td>{{ chart3_data[0]['car_odo_meter'] }} km</td>
                        </tr>
                        <tr>
                          <th>Cell Voltage Diff.</th>
                          <td>{{ chart3_data[0]['cell_second_voltage'] }} V</td>
                        </tr>
                        <tr>
                          <th>Module Temp. Diff.</th>
                          <td>{{ chart3_data[0]['cell_sub_temperature'] }} &#8451;</td>
                        </tr>
                        <tr>
                          <th>Rapid Accel/Decel</th>
                          <td>{{ chart3_data[0]['car_rapid'] }} times</td>
                        </tr>
                        <tr>
                          <th>Cabin Temp.</th>
                          <td>{{ chart3_data[0]['car_inside_temperature'] }} &#8451;</td>
                        </tr>
                        <tr>
                          <th>Charge/Discharge Rate</th>
                          <td>{{ chart3_data[0]['bat_discharge_crate'] }} C</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tbl2">
                    <table>
                      <colgroup>
                        <col style="width: 30%;" />
                        <col style="width: 70%;" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th colspan="2">{{ car_number_select.name }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>Battery SOH</th>
                          <td>{{ chart3_data[2]['bat_soh'] }} %</td>
                        </tr>
                        <tr>
                          <th>Mileage</th>
                          <td>{{ chart3_data[2]['car_odo_meter'] }} km</td>
                        </tr>
                        <tr>
                          <th>Cell Voltage Diff.</th>
                          <td>{{ chart3_data[2]['cell_second_voltage'] }} V</td>
                        </tr>
                        <tr>
                          <th>Module Temp. Diff.</th>
                          <td>{{ chart3_data[2]['cell_sub_temperature'] }} &#8451;</td>
                        </tr>
                        <tr>
                          <th>Rapid Accel/Decel</th>
                          <td>{{ chart3_data[2]['car_rapid'] }} 회</td>
                        </tr>
                        <tr>
                          <th>Cabin Temp.</th>
                          <td>{{ chart3_data[2]['car_inside_temperature'] }} &#8451;</td>
                        </tr>
                        <tr>
                          <th>Charge/Discharge Rate</th>
                          <td>{{ chart3_data[2]['bat_discharge_crate'] }} C</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import anychart from 'anychart'
export default {
  name: 'GradeStatusTrend',

  data () {
    return {
      route_option: 0,
      chart1_data: '',
      chart2_data: '',
      chart3_data: [
        {
          bat_soh: '',
          car_odo_meter: '',
          cell_second_voltage: '',
          cell_sub_temperature: '',
          car_rapid: '',
          car_inside_temperature: '',
          bat_discharge_crate: '',
        },
        {
          bat_soh: '',
          car_odo_meter: '',
          cell_second_voltage: '',
          cell_sub_temperature: '',
          car_rapid: '',
          car_inside_temperature: '',
          bat_discharge_crate: '',
        },
        {
          bat_soh: '',
          car_odo_meter: '',
          cell_second_voltage: '',
          cell_sub_temperature: '',
          car_rapid: '',
          car_inside_temperature: '',
          bat_discharge_crate: '',
        },
        {
          bat_soh: '',
          car_odo_meter: '',
          cell_second_voltage: '',
          cell_sub_temperature: '',
          car_rapid: '',
          car_inside_temperature: '',
          bat_discharge_crate: '',
        },
      ],
      route_list: '',
      grade: [0,0,0,0,0],
      grade_total: 0,
      car_list: '',
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth(),
      car_number_select: {
        idx: 0,
        name: 'All Vehicles'
      }, 
      route_select:{
        idx: 0,
        name: 'All Routes'
      },
      title: {
        car_cnt: 0,
    bat_grade: 0
    },

    }
  },
  
  watch: {
    selectedYear: function(){
      this.gradestatus_get_grade();
      this.get_chart_data();
    },
    selectedMonth: function(){
      this.get_chart_data();
    },

  },

   mounted () {
      // kps
    this.gradetrend_get_title_count(); // 타이틀 정보 가져오기
      this.get_route_list(); // 라우트 정보 가져오기
      this.gradestatus_get_grade(); // 등급정보 가져오기
      this.get_car_list(); // 노선에 맞는 차량정보 가져오기
      this.get_chart_data(); // 차트 데이터 가져오기
  },
    
  methods: {
    gradetrend_get_title_count(){
      var post_data = {group_id: this.$store.getters.getGroupId};
        this.$axios.post('/api/gradetrend_get_title_count', post_data).then(res => {
          this.title = res.data.result[0];
        });
    },

    // 연동 옵션 변경시 데이터 새로 설정
    change_year(data){
      // 0 : 년도감소
      // 1 : 년도증가
      if(data == 0) {
        this.selectedYear += 1;
      }else if(data == 1) {
        this.selectedYear -= 1;
      }
    },

    // 옵션 선택시 데이터 새로 설정
    change_route (){
      // 라우터 옵션 값 변경
      this.route_option = this.route_select.idx;

      this.get_car_list(); // 차량 번호 가져오기
      this.get_chart_data(); // 차트 데이터 조회
    },

    // 차량 번호 옵션 선택시 데이터 새로 설정
    change_car (){
      this.get_chart_data(); // 차트 데이터 조회
    },

    // 노선 목록 조회
    get_route_list () {
      var post_data = {group_id: this.$store.getters.getGroupId};
      this.$axios.post('/api/get_route_list', post_data).then(res => {
        this.route_list = res.data.rows;
      });
    },
    
    // 배터리 등급추이, 년도별 등급차트 데이터 가져오기
    gradestatus_get_grade: function(){
      var post_data = {year_option: this.selectedYear, route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/gradestatus_trend_get_grade', post_data).then(res => {
        this.chart1_data = res.data.result[0];
        this.chart2_data = res.data.result[1];
        
        this.anychart(); // 잔존수명, 안전성, 사용성
        this.anychart2();
      });
    },

    // 노선에 해당하는 차량정보 조회
    get_car_list () {
      var post_data = {route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/get_car_list', post_data).then(res => {
        this.car_list = res.data.result[0];
      });
    },

    // 차트 데이터 조회
    get_chart_data(){
      var post_data = {year_option: this.selectedYear, route_option: this.route_option, car_option: this.car_number_select.idx, month_option: this.selectedMonth, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/gradetrend_get_chart_data', post_data).then(res => {
        this.chart3_data = res.data.result[0];
        
        this.anychart3();
      });
    },
    
    anychart: function () {
        this.$refs.anychart.innerHTML = "";
        anychart.onDocumentReady(() => {
          // create line chart
            var chart = anychart.line();
            chart.noData().label().enabled(true);
            chart.noData().label().text("No Data");
            
            // set chart padding
            chart.padding([10, 20, 5, 20]);

            // turn on chart animation
            chart.animation(true);

            // turn on the crosshair
            //chart.crosshair(true);

            // set chart title text settings
            //chart.title('Customers Activity during the Week');

            // set y axis title
            //chart.yAxis().title('Activity occurrences');

            // create logarithmic scale
            var logScale = anychart.scales.log();
            logScale.minimum(1).maximum(45000);

            // set scale for the chart, this scale will be used in all scale dependent entries such axes, grids, etc
            chart.yScale(logScale);

            // create data set on our data,also we can pud data directly to series
            var dataSet = anychart.data.set(this.chart1_data);

            // map data for the first series,take value from first column of data set
            var firstSeriesData = dataSet.mapAs({ x: 0, value: 1 });

            // map data for the second series,take value from second column of data set
            var secondSeriesData = dataSet.mapAs({ x: 0, value: 2 });

            // map data for the third series, take x from the zero column and value from the third column of data set
            var thirdSeriesData = dataSet.mapAs({ x: 0, value: 3 });

            // temp variable to store series instance
            var series;

            // setup first series
            series = chart.line(firstSeriesData);
            series.name('Remaining Life');
            // enable series data labels
            series.labels().enabled(true).anchor('left-bottom').padding(5);
            // enable series markers
            series.markers(true);

            // setup second series
            series = chart.line(secondSeriesData);
            series.name('Safety');
            // enable series data labels
            series.labels().enabled(true).anchor('left-bottom').padding(5);
            // enable series markers
            series.markers(true);

            // setup third series
            series = chart.line(thirdSeriesData);
            series.name('Usability');
            // enable series data labels
            series.labels().enabled(true).anchor('left-bottom').padding(5);
            // enable series markers
            series.markers(true);

            // turn the legend on
            chart.legend().enabled(false).fontSize(13).padding([0, 0, 20, 0]);
            
            // 차트 색 입히기
            /*var palette = anychart.palettes.rangeColors();
            palette.items([{ color: '#64b5f6' }, { color: '#ef6c00' }, {color: '#1976d2'}]);
            chart.palette(palette);*/

            //워터마커 제거
            anychart.licenseKey("4dream-8254134a-23a23715");
            var credits = chart.credits();
            credits.enabled(false);

            // grid set
            chart.yGrid(true);
            
            // set container for the chart and define padding
            chart.container('anychart');
            // initiate chart drawing
            chart.draw();
        });
      },

    anychart2: function () {
      this.$refs.anychart2.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create data set on our data
        var dataSet = anychart.data.set([
          ['Jan', this.chart2_data[0][0], this.chart2_data[0][1], this.chart2_data[0][2], this.chart2_data[0][3], this.chart2_data[0][4]],
          ['Feb', this.chart2_data[1][0], this.chart2_data[1][1], this.chart2_data[1][2], this.chart2_data[1][3], this.chart2_data[1][4]],
          ['Mar', this.chart2_data[2][0], this.chart2_data[2][1], this.chart2_data[2][2], this.chart2_data[2][3], this.chart2_data[2][4]],
          ['Apr', this.chart2_data[3][0], this.chart2_data[3][1], this.chart2_data[3][2], this.chart2_data[3][3], this.chart2_data[3][4]],
          ['May', this.chart2_data[4][0], this.chart2_data[4][1], this.chart2_data[4][2], this.chart2_data[4][3], this.chart2_data[4][4]],
          ['Jun', this.chart2_data[5][0], this.chart2_data[5][1], this.chart2_data[5][2], this.chart2_data[5][3], this.chart2_data[5][4]],
          ['Jul', this.chart2_data[6][0], this.chart2_data[6][1], this.chart2_data[6][2], this.chart2_data[6][3], this.chart2_data[6][4]],
          ['Aug', this.chart2_data[7][0], this.chart2_data[7][1], this.chart2_data[7][2], this.chart2_data[7][3], this.chart2_data[7][4]],
          ['Sep', this.chart2_data[8][0], this.chart2_data[8][1], this.chart2_data[8][2], this.chart2_data[8][3], this.chart2_data[8][4]],
          ['Oct', this.chart2_data[9][0], this.chart2_data[9][1], this.chart2_data[9][2], this.chart2_data[9][3], this.chart2_data[9][4]],
          ['Nov', this.chart2_data[10][0], this.chart2_data[10][1], this.chart2_data[10][2], this.chart2_data[10][3], this.chart2_data[10][4]],
          ['Dec', this.chart2_data[11][0], this.chart2_data[11][1], this.chart2_data[11][2], this.chart2_data[11][3], this.chart2_data[11][4]],
        ]);

        // map data for the first series, take x from the zero column and value from the first column of data set
        var firstSeriesData = dataSet.mapAs({ x: 0, value: 1 });

        // map data for the second series, take x from the zero column and value from the second column of data set
        var secondSeriesData = dataSet.mapAs({ x: 0, value: 2 });

        // map data for the second series, take x from the zero column and value from the third column of data set
        var thirdSeriesData = dataSet.mapAs({ x: 0, value: 3 });

        // map data for the fourth series, take x from the zero column and value from the fourth column of data set
        var fourthSeriesData = dataSet.mapAs({ x: 0, value: 4 });

        // create bar chart
        var chart = anychart.column();
        chart.noData().label().enabled(true);
        chart.noData().label().text("No Data");
        
        // turn on chart animation
        chart.animation(true);

        // force chart to stack values by Y scale.
        chart.yScale().stackMode('percent');

        // set chart title text settings
        //chart.title('Regional ratio of cosmetic products sales');

        // set yAxis labels formatting, force it to add % to values
        chart.yAxis(0).labels().format('{%Value}');

        // helper function to setup label settings for all series
        var setupSeries = function (series, name) {
          series.name(name).stroke('2 #fff 1');
          series.hovered().stroke('2 #fff 1');
        };

        // temp variable to store series instance
        var series;

        // create first series with mapped data
        series = chart.column(firstSeriesData);
        setupSeries(series, 'Grade 1');

        // create second series with mapped data
        series = chart.column(secondSeriesData);
        setupSeries(series, 'Grade 2');

        // create third series with mapped data
        series = chart.column(thirdSeriesData);
        setupSeries(series, 'Grade 3');

        // create fourth series with mapped data
        series = chart.column(fourthSeriesData);
        setupSeries(series, 'Grade 4');

        series = chart.column(fourthSeriesData);
        setupSeries(series, 'Grade 5');

        chart.interactivity().hoverMode('by-x');
        chart.tooltip().titleFormat('{%X}').displayMode('union');

        // turn on legend
        chart.legend().enabled(false);

        // 단위
        chart.yAxis().title("Ratio (%)");

        var palette = anychart.palettes.rangeColors();
        palette.items([{ color: '#dfaf79' }, { color: '#c55d3c' }, {color: '#cb555f'}, {color: '#a2232d'}, {color: '#781825'}]);
        chart.palette(palette);

        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        // grid set
        chart.yGrid(true);
        
        // set container id for the chart
        chart.container('anychart2');

        // initiate chart drawing
        chart.draw();
      });
    },

    anychart3: function () {
      this.$refs.anychart3.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create data set on our data
      var dataSet = anychart.data.set([
        ['Battery SOH', this.chart3_data[1]['bat_soh'], this.chart3_data[3]['bat_soh']],
        ['Mileage', this.chart3_data[1]['car_odo_meter'], this.chart3_data[3]['car_odo_meter']],
        ['Cell Voltage Diff.', this.chart3_data[1]['cell_second_voltage'], this.chart3_data[3]['cell_second_voltage']],
        ['Module Temp. Diff.', this.chart3_data[1]['cell_sub_temperature'], this.chart3_data[3]['cell_sub_temperature']],
        ['Rapid Accel/Decel', this.chart3_data[1]['car_rapid'], this.chart3_data[3]['car_rapid']],
        ['Cabin Temp.', this.chart3_data[1]['car_inside_temperature'], this.chart3_data[3]['car_inside_temperature']],
        ['Charge/Discharge Rate', this.chart3_data[1]['bat_discharge_crate'], this.chart3_data[3]['bat_discharge_crate']]
      ]);

      // map data for the first series, take x from the zero column and value from the first column of data set
      var data1 = dataSet.mapAs({ x: 0, value: 1 });
      // map data for the second series, take x from the zero column and value from the second column of data set
      var data2 = dataSet.mapAs({ x: 0, value: 2 });
      // map data for the third series, take x from the zero column and value from the third column of data set
      var data3 = dataSet.mapAs({ x: 0, value: 3 });

      // create radar chart
      var chart = anychart.radar();
      chart.noData().label().enabled(true);
      chart.noData().label().text("No Data");
      
      // set chart yScale settings
      chart.yScale().minimum(0).maximumGap(0).ticks().interval(50);

      // set xAxis labels settings
      chart.xAxis().labels().padding(5);

      // set chart legend settings
      chart.legend().align('center').enabled(false);

      // create first series with mapped data
      var series1 = chart.line(data1).name('Shaman');
      series1.markers().enabled(true).type('circle').size(3);
      // create first series with mapped data
      var series2 = chart.line(data2).name('Warrior');
      series2.markers().enabled(true).type('circle').size(3);
      // create first series with mapped data
      var series3 = chart.line(data3).name('Priest');
      series3.markers().enabled(true).type('circle').size(3);

      // chart tooltip format
      chart.tooltip().format('Value: {%Value}');

      var palette = anychart.palettes.rangeColors();
      palette.items([{ color: '#34a789' }, { color: '#e84219' }]);
      chart.palette(palette);

      //워터마커 제거
      anychart.licenseKey("4dream-8254134a-23a23715");
      var credits = chart.credits();
      credits.enabled(false);
      
      // turn on chart animation
      chart.animation(true);

      // set container id for the chart
      chart.container('anychart3');
      chart.draw();
      });
    },
},

  whatch: {

  }
}
</script>

<style lang="scss" scoped>
$defaultMargin: 25px;

#main {
  padding: $defaultMargin;
  overflow-y: auto;
  @include mobile {
    padding: 10px;
  }

  .wrapper {
    width: 100%;
    min-width: 1400px;
    min-height: 100%;
    position: relative;
    @include mobile {
      min-width: 100%;
    }
  }

  .select {
    width: 100%;
    text-align: right;
    margin-bottom: $defaultMargin;
  }

  .contents {
    display: grid;
    grid-template-columns: 3.75fr 6.25fr;
    grid-template-rows: 3.5fr 5fr;
    gap: $defaultMargin;
    @include mobile {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    &__container {
      min-height: 350px;
      background: #fff;
      border: 1px solid #979797;
      padding: 25px;
      border-radius: 6px;
      @include mobile {
        padding: 10px;
        min-height: 0;
        margin-bottom: 10px;
      }

      &__chart {
        width: 100%;
        height: calc(100% - 54px);
        display: flex;
        justify-content: center;
        align-items: center;
        @include mobile {
          flex-direction: column;
        }
        &__box {
          width: 43.7%;
          height: 100%;
        }
        &__table {
          width: 56.3%;
          height: 100%;
          border: 1px solid #5c5c5c;
          border-radius: 6px;
          table {
            width: 100%;
            height: 100%;
            text-align: center;
            thead {
              border-bottom: 1px solid #5c5c5c;
              th {
                background: #077f80;
                color: #fff;
                height: 37px;
                &:first-child {
                  border-right: 1px solid #fff;
                }
              }
            }
            tbody {
              font-size: 15px;
              tr {
                min-height: 25px;
                th {
                  font-weight: 500;
                  border-right: 1px solid #5c5c5c;
                  span {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    border-radius: 2px;
                    background: #000;
                    vertical-align: -5px;
                    margin-right: 4px;
                  }
                }
                &:nth-child(1) th span { background: #7dc8bc; }
                &:nth-child(2) th span { background: #69c4c5; }
                &:nth-child(3) th span { background: #37b8af; }
                &:nth-child(4) th span { background: #28ac8b; }
                &:nth-child(5) th span { background: #15897a; }
              }
            }
          }
        }
      }

      &2 {
        position: relative;
        &.cont1 {
          @include mobile {
            border-bottom: none;
            border-end-end-radius: 0;
            border-end-start-radius: 0;
            margin-bottom: 0;
          }
        }
        &.cont2 {
          @include mobile {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border-top: none;
            margin-top: -1px;
          }
        }
        .contents__container {
        &__year {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 30px;
            position: absolute;
            top: 25px;
            right: 0;
            width: 100%;
            @include mobile {
              display: none;
            }
            &.mob {
              display: none;
              top: 16px;
              right: 10px;
              justify-content: flex-end;
              @include mobile {
                display: flex;
              }
            }
          p {
            font-size: 26px;
            font-weight: 700;
            margin: 0 14px;
              @include mobile {
                font-size: 20px;
                margin: 0 10px;
              }
          }
          button {
            width: 31px;
            height: 19px;
            background-repeat: no-repeat;
            background-position: center;
              @include mobile {
                padding: 5px 0;
              }
          }
          .prev {
            background-image: url('~@/assets/images/icon/arrow_prev.png');
          }
          .next {
            background-image: url('~@/assets/images/icon/arrow_next.png');
          }
        }
        &__chart {
          height: calc(100% - 63px);
          &__box {
            width: calc(100% - 134px);
              @include mobile {
                width: 100%;
                height: 200px;
              }
          }
          &__table {
            width: 134px;
            border: none;
              @include mobile {
                width: auto;
              }
            ul {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
                @include mobile {
                  flex-direction: row;
                  padding: 5px 10px;
                  border: 1px solid #979797;
                  border-radius: 4px;
                }
              li {
                display: flex;
                font-size: 15px;
                margin-bottom: 19px;
                  white-space: nowrap;
                  @include mobile {
                    margin-bottom: 0;
                    margin-right: 8px;
                    font-size: 12px;
                  }
                  &:last-child { margin-bottom: 0; margin-right: 0; }
                span {
                  width: 20px;
                  height: 20px;
                  border-radius: 2px;
                  margin-right: 15px;
                    @include mobile {
                      width: 15px;
                      height: 15px;
                      margin-right: 8px;
                    }
                }
                &:nth-child(1) span { background: #dfaf79; }
                &:nth-child(2) span { background: #c55d3c; }
                &:nth-child(3) span { background: #cb555f; }
                &:nth-child(4) span { background: #a2232d; }
                &:nth-child(5) span { background: #781825; }
              }
            }
          }
        }
      }
      }

      &3 {
        $chartWidth: 560px;
        grid-column: 1/3;
        position: relative;
        height: 500px;
        padding: {
          left: 0;
          bottom: 0;
        }
        @include mobile {
          height: 1120px;
          margin-bottom: 0;
        }
        .title-style-1 {
          margin-bottom: 5px;
          margin-left: 25px;
          @include mobile {
            z-index: 1;
            margin-left: 10px;
          }
        }
        .contents__container__select {
          position: absolute;
          top: 25px;
          right: 25px;
          @include mobile {
            top: 494px;
            left: 10px;
            z-index: 9;
            display: flex;
            flex-wrap: nowrap;
          }
          select {
            margin-left: 12px;
            @include mobile {
              margin-left: 0;
              margin-right: 10px;
            }
          }
        }
        .contents__container__chart {
          height: calc(100% - 34px);
          position: relative;
          @include mobile {
            position: absolute;
            top: 50px;
            left: 0;
            width: 100%;
            // height: 100%;
            justify-content: flex-start;
          }
          &__box {
            width: 100%;
          }
          .container {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            @include mobile {
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              height: auto;
            }
            .chart-container {
              width: $chartWidth; 
              height: 100%;
              @include mobile {
                width: 100%;
                height: 300px;
              }
            }
            .table-container {
              width: calc(100% - #{$chartWidth} - 190px);
              height: 100%;
              display: flex;
              padding-top: $defaultMargin;
              padding-bottom: $defaultMargin;
              @include mobile {
                width: calc(100% - 20px);
                height: auto;
                margin-top: 184px;
                flex-direction: column;
                padding: 0;
              }
              >div {
                width: calc(50% - (#{$defaultMargin} / 2));
                height: 100%;
                border: 1px solid #979797;
                border-radius: 16px;
                overflow: hidden;
                @include mobile {
                  width: 100%;
                  border-radius: 6px;
                  margin-bottom: 10px;
                }
                &:first-child {
                  margin-right: $defaultMargin;
                  @include mobile {
                    margin-right: 10px;
                  }
                }
              }
              table {
                width: 100%;
                height: 100%;
                th, td {
                  height: 46px;
                  border-bottom: 1px solid #979797;
                  border-right: 1px solid #979797;
                  color: #231815;
                  @include mobile {
                    height: 35px;
                  }
                  &:last-child {
                    border-right: none;
                  }
                }
                thead th {
                  font-weight: 900;
                }
                tbody tr {
                  th {
                    font-weight: 600;
                    @include mobile {
                      min-width: 120px;
                    }
                  }
                  td {
                    font-weight: 300;
                    text-align: center;
                  }
                  &:last-child {
                    th, td {
                      border-bottom: none;
                    }
                  }
                }
              }
              .tbl1 {
                table {
                  thead th {
                    background: #f5f8fa;
                  }
                  tbody th {
                    background: #e3f2f1;
                    color: #107a7b;
                  }
                }
              }
              .tbl2 {
                table {
                  thead th {
                    background: #fdeceb;
                  }
                  tbody th {
                    background: #f1cfc6;
                    color: #51271c;
                  }
                }
              }
            }
          }
        }
        .chart-legend {
          position: absolute;
          bottom: $defaultMargin;
          left: $chartWidth;
          width: 147px;
          height: 79px;
          border: 1px solid #231815;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3), 0 -1px 1px rgba(0, 0, 0, 0.3);
          @include mobile {
            position: static;
            margin: 0 auto;
            width: 100%;
            height: auto;
            border: none;
            box-shadow: none;
            display: inline-flex;
          }
          ul {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            @include mobile {
              border: 1px solid #979797;
              padding: 5px 10px;
              flex-direction: row;
            }
            li {
              display: flex;
              align-items: center;
              width: 104px;
              @include mobile {
                font-size: 12px;
                width: auto;
              }
              span {
                display: block;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                margin-right: 15px;
                background: #34a789;
                @include mobile {
                  margin-right: 8px;
                }
              }
              &:last-child {
                margin-top: 12px;
                @include mobile {
                  margin-top: 0;
                  margin-left: 8px;
                }
                span {
                  background: #e84219;
                }
              }
            }
          }
        }
      }

      &__month {
        position: absolute;
        top: $defaultMargin;
        right: 390px;
        padding-left: 40px;
        height: 31px;
        display: flex;
        @include mobile {
          left: 50%;
          transform: translateX(-50%);
          right: auto;
          top: 390px;
          width: calc(100% - 20px);
          padding: 10px 20px 10px 10px;
          height: auto;
          background-size: 30px;
          border: 1px solid #979797;
          border-radius: 4px;
          background-position-x: 6vw;
          z-index: 9;
        }
        &__img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          @include mobile {
            width: 10vw;
            margin-right: 10px;
          }
        }
        &__btn {
          display: flex;
          @include mobile {
            width: calc(100% - (10vw + 10px));
            flex-direction: column;
          }
        ul {
          display: flex;
          height: 100%;
          align-items: center;
            @include mobile {
              width: 100%;
              justify-content: space-between;
              &:first-child {
                margin-bottom: 10px;
              }
            }
          li {
            height: 100%;
            margin-left: 17px;
              @include mobile {
                margin-left: 0;
              }
            button {
              border: 1px solid #0c978e;
              color: #0c978e;
              background: #fff;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 31px;
              height: 31px;
              font-size: 12px;
              &.active {
                background: #0c978e;
                color: #fff;
                box-shadow: 0 3px 4px rgba(0, 0, 0, 0.3);
              }
            }
          }
        }
      }
    }
  }
}
}
</style>